import { Value } from './Value';
const removeEmptyProperties = () => (input) => {
    const newObject = {};
    for (const key in input) {
        if (input[key] !== undefined) {
            newObject[key] = input[key];
        }
    }
    return newObject;
};
const filter = (predicate) => (input) => {
    const newObject = {};
    for (const key in input) {
        const value = input[key];
        if (predicate(value)) {
            newObject[key] = value;
        }
    }
    return newObject;
};
const removeNullableProperties = () => (input) => {
    const newObject = {};
    for (const key in input) {
        if (input[key] !== null) {
            newObject[key] = input[key];
        }
    }
    return newObject;
};
const isEmptyRecord = () => (input) => {
    return Object.keys(input).length === 0;
};
const shallowMerge = (inputB) => (inputA) => {
    return { ...inputA, ...inputB(inputA) };
};
const replace = (key, replacer) => input => {
    return { ...input, [key]: replacer(input[key]) };
};
const myObj = { c: 1 };
const thing = replace('a', value => myObj.c)({
    a: 'world',
    b: 'test',
});
const hasKey = (key) => (obj) => {
    return key in obj;
};
const evolveObject = (plan, input) => {
    const planKeys = Object.keys(plan);
    let result;
    for (let i = 0; i < planKeys.length; i++) {
        const key = planKeys[i];
        const step = plan[key];
        const current = input[key];
        if (!Object.prototype.hasOwnProperty.call(input, key))
            continue;
        if (typeof step === 'function') {
            const next = step(current);
            if (next !== current) {
                if (result === undefined)
                    result = { ...input };
                result[key] = next;
            }
            continue;
        }
        if (!Value.isObject(step) || !Value.isObject(current))
            continue;
        const next = evolveObject(step, current);
        if (next !== current) {
            if (result === undefined)
                result = { ...input };
            result[key] = next;
        }
    }
    return result ?? input;
};
const evolve = (plan) => (input) => {
    if (!Value.isObject(input)) {
        throw new Error('Record.evolve expected a non-array object');
    }
    return evolveObject(plan, input);
};
const deepCopy = (input) => {
    if (input === null || typeof input !== 'object') {
        return input;
    }
    if (input instanceof Date) {
        return new Date(input.getTime());
    }
    if (input instanceof RegExp) {
        return new RegExp(input);
    }
    if (Array.isArray(input)) {
        return input.map(deepCopy);
    }
    const output = {};
    for (const key in input) {
        if (Object.prototype.hasOwnProperty.call(input, key)) {
            output[key] = deepCopy(input[key]);
        }
    }
    return output;
};
export const Record = {
    removeEmptyProperties,
    removeNullableProperties,
    isEmptyRecord,
    filter,
    shallowMerge,
    replace: replace,
    hasKey,
    deepCopy,
    evolve,
};
//# sourceMappingURL=Record.js.map